export default __webpack_public_path__ + "static/media/BMMF-BG.fde0dc0e.webp";